// The viewer rail's compact counts (FR-C29 v2.10): 86 · 1.2k · 15.6k · 2.1M, in the active
// language's digits. Pure — unit-tested. One named file for the reel screens (CB-D3).
import { formatNumber } from '@bookingdei/i18n/format-number';

type Lang = Parameters<typeof formatNumber>[0];
type Translate = (key: 'reels.count_k' | 'reels.count_m', params: { n: string }) => string;

export function compactCount(lang: Lang, n: number, t: Translate): string {
  const v = Math.max(0, Math.floor(n));
  if (v < 1000) return formatNumber(lang, v);
  if (v < 1_000_000) return t('reels.count_k', { n: formatNumber(lang, Math.floor(v / 100) / 10, { maxFractionDigits: 1 }) });
  return t('reels.count_m', { n: formatNumber(lang, Math.floor(v / 100_000) / 10, { maxFractionDigits: 1 }) });
}
